import "./index.css";
import React from "react";
import { Composition, Folder } from "remotion";
import { VIDEO } from "./theme";
import { Video, SCENES, TOTAL_FRAMES } from "./Video";

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Composition
        id="TuRastreoLogistica"
        component={Video}
        durationInFrames={TOTAL_FRAMES}
        fps={VIDEO.fps}
        width={VIDEO.width}
        height={VIDEO.height}
        defaultProps={{ narration: true }}
      />
      <Folder name="Escenas">
        {SCENES.map((s) => (
          <Composition
            key={s.id}
            id={s.id}
            component={s.comp}
            durationInFrames={Math.round(s.dur * VIDEO.fps)}
            fps={VIDEO.fps}
            width={VIDEO.width}
            height={VIDEO.height}
          />
        ))}
      </Folder>
    </>
  );
};
